import React, { Component } from "react";
import {Link} from "react-router-dom";

const PortfolioListContent = [
    {
        image: 'image-1',
        category: 'MongoDB, Express.js, ReactJS, Node.js',
        title: 'Aesthetic Setups',
        github: 'https://github.com/pgf96/aesthetic-setups',
        site: 'https://aestheticsetups.herokuapp.com/',
    },
    {
        image: 'image-image-label',
        category: 'ReactJS, D3',
        title: 'image-label',
        github: 'https://github.com/pgf96/image-label',
        site: '',
    },
    {
        image: 'image-2',
        category: 'Django, PostgreSQL',
        title: 'Four Paw Finder',
        github: 'https://github.com/pgf96/fourpawfinder',
        site: 'https://fourpawfinder.herokuapp.com/',
    },
    {
        image: 'image-3',
        category: 'Express.js, Node.js',
        title: 'e-learning',
        github: 'https://github.com/pgf96/e-learning',
        site: '',
    },
    {
        image: 'image-4',
        category: 'JS, HTML, CSS',
        title: 'Minesweeper',
        github: 'https://github.com/pgf96/Minesweeper',
        site: 'https://pgf96.github.io/Minesweeper/',
    },
]

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`portfolio ${styevariation}`}>
                            <div className="thumbnail-inner">
                                <div className={`thumbnail ${value.image}`}></div>
                                <div className={`bg-blr-image ${value.image}`}></div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <h4><a href="/portfolio-details">{value.title}</a></h4>
                                    <p>{value.category}</p>
                                    <div className="portfolio-button">
                                    {value.site ? (
  <>
    <a className="rn-btn" href={value.site}>Live Site</a> &nbsp;
    <a className="rn-btn" href={value.github}>Github</a>
  </>
) : (
  <a className="rn-btn" href={value.github}>Github</a>
)}

                                        
                                    </div>
                                </div>
                            </div>
                            <Link className="link-overlay" to="/portfolio-details"></Link>
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;